// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPasswordView__container","text":"ResetPasswordView__text","form":"ResetPasswordView__form","returnButtonContainer":"ResetPasswordView__returnButtonContainer"};